import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import { getLatestTaskList } from "../Firebase/getLatestTaskListAction";
import * as idb from '../../../functions/databaseService/indexedDB';
import signOut from "../../../functions/userIdentity/signOut";
import { getItem } from "../../../utils/storageHelper";

// Action Types
export const FIREBASE_DELETE_TASK_SUCCESS = "FIREBASE_DELETE_TASK_SUCCESS";
export const FIREBASE_DELETE_TASK_ERROR = "FIREBASE_DELETE_TASK_ERROR";

// Thunk Action Creator
export const deleteTaskFromFirebase = createAsyncThunk(
    "api/Task/deleteTask",
    async (json, { dispatch }) => {
        try {
            const firebaseData = await getItem(`firebase:user:${import.meta.env.VITE_PUBLIC_APP_ENV}`);
            const user = JSON.parse(firebaseData);

            const online = navigator.onLine;

            if (online) {
                const response = await axios.delete(
                    `${import.meta.env.VITE_PUBLIC_DOMAIN}Task/deleteTask/${json.id}`,
                    {
                        id: json.id
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                )
                if (response.status == 200) {
                    if (response.data === '') {
                        throw new Error("The last task has not been saved. Logging the user out");
                    } else {
                        idb.storeTaskList(response.data.tasks || response.data);
                    }
                }
                else {
                    throw new Error("Error deleting task from firebase");
                }

                dispatch({
                    type: FIREBASE_DELETE_TASK_SUCCESS,
                    payload: response.data,
                });

            }
            else {
                //get data from indexed DB
                const taskListData = await idb.getTasks();
                if (taskListData) {
                    //Dispatch Indexed DB instead of Axios result
                    dispatch({
                        type: FIREBASE_GET_LATEST_TASK_FILE_SUCCESS,
                        payload: taskListData
                    });
                }
                else {
                    console.log("No tasks found in IndexedDB");
                }
            }

        }
        catch (error) {
            dispatch({ type: FIREBASE_DELETE_TASK_ERROR, payload: error });
            await signOut();
        }

        //.then(response => {
        //    const taskListData = response.data;
        //    dispatch({
        //        type: FIREBASE_DELETE_TASK_SUCCESS,
        //        payload: taskListData,
        //    });
        //    dispatch(getLatestTaskList());
        //})
        //.catch(error => {
        //    dispatch({ type: FIREBASE_DELETE_TASK_ERROR, payload: error });
        //});
        //}
    });
